const o = "689760566032-nnmetbiclo33bob8e94j38s1n81d2qf4.apps.googleusercontent.com";
export {
  o as GOOGLE_CLIENT_ID
};
//# sourceMappingURL=index.es667.js.map
